import { createAction } from '@reduxjs/toolkit';

import type {
  CreateTestCasePayload,
  DeleteTestCasePayload,
  SetTestCaseAssertionsPayload,
  SetTestCaseFunctionCallsPayload,
  SetTestCaseTagsPayload,
  UpdateTestCasePayload,
} from '@polyai/schemas';

const TEST_CASE_PREFIX = 'testing/testCase';

export const createTestCase = createAction<CreateTestCasePayload>(
  `${TEST_CASE_PREFIX}/create`,
);

export const updateTestCase = createAction<UpdateTestCasePayload>(
  `${TEST_CASE_PREFIX}/update`,
);

export const deleteTestCase = createAction<DeleteTestCasePayload>(
  `${TEST_CASE_PREFIX}/delete`,
);

export const setTestCaseAssertions = createAction<SetTestCaseAssertionsPayload>(
  `${TEST_CASE_PREFIX}/setAssertions`,
);

export const setTestCaseFunctionCalls =
  createAction<SetTestCaseFunctionCallsPayload>(
    `${TEST_CASE_PREFIX}/setFunctionCalls`,
  );

export const setTestCaseTags = createAction<SetTestCaseTagsPayload>(
  `${TEST_CASE_PREFIX}/setTags`,
);
